import { useFlag } from '@/lib/api';

/** Must exist in the license server per deployment before any table header sorts. */
const TABLE_SORTING_FLAG = 'table_sorting_EOL1851';

/** Separate from the hook so the gate can be tested without mocking `@/lib/api`. */
export function isTableSortingEnabled(flag: { data?: boolean }): boolean {
    return flag.data === true;
}

export function useTableSortingFlag(): boolean {
    return isTableSortingEnabled(useFlag(TABLE_SORTING_FLAG));
}
